import { Button, Menu, type MenuProps } from "antd";
import Sider from "antd/es/layout/Sider";
import { Activity, useState } from "react";
import { Icon } from "@iconify/react";
import { Link, useLocation } from "react-router";
import ArrowLeft from "../svg/ArrowLeft";

type MenuItem = Required<MenuProps>["items"][number];

export default function SideBar() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  const items: MenuItem[] = [
    {
      key: "/",
      label: (
        <Link className="text-16-regular!" to={"/"}>
          داشبورد
        </Link>
      ),
      icon: <Icon className="mr-1.5!" icon={"solar:widget-bold-duotone"} />,
    },
    {
      key: "analyze",
      label: (
        <Link className="text-16-regular!" to={"/"}>
          آنالیز
        </Link>
      ),
      icon: <Icon className="mr-1.5!" icon={"solar:chart-bold-duotone"} />,
    },
    {
      key: "FAQ",
      label: <span className="text-16-regular!">سوالات متداول</span>,
      icon: (
        <Icon className="mr-1.5!" icon={"solar:question-circle-bold-duotone"} />
      ),
      children: [
        {
          key: "/faq-category",
          label: (
            <Link className="text-16-regular!" to={"/faq-category"}>
              دسته بندی سوالات متداول
            </Link>
          ),
        },
        {
          key: "/faq",
          label: (
            <Link className="text-16-regular!" to={"/faq"}>
              مدیریت سوالات متداول
            </Link>
          ),
        },
      ],
    },
    {
      key: "support",
      label: <span className="text-16-regular!">پشتیبانی</span>,
      icon: (
        <Icon
          className="mr-1.5!"
          icon={"solar:headphones-round-bold-duotone"}
        />
      ),
      children: [
        {
          key: "/ticket-category",
          label: (
            <Link className="text-16-regular!" to={"/ticket-category"}>
              دسته بندی تیکت
            </Link>
          ),
        },
        {
          key: "/ticket",
          label: (
            <Link className="text-16-regular!" to={"/ticket"}>
              تیکت ها
            </Link>
          ),
        },
        {
          key: "/management-information-contact-us",
          label: (
            <Link
              className="text-16-regular!"
              to={"/management-information-contact-us"}
            >
              تماس با ما
            </Link>
          ),
        },
      ],
    },
    {
      key: "content-management",
      label: <span className="text-16-regular">مدیریت محتوا</span>,
      type: "group",
      children: [
        {
          key: "news",
          label: <span className="text-16-regular!">اخبار و مقالات</span>,
          icon: <Icon className="mr-1.5!" icon={"solar:notes-bold-duotone"} />,
          children: [
            {
              key: "/blog-category",
              label: (
                <Link className="text-16-regular!" to={"/blog-category"}>
                  مدیریت دسته بندی
                </Link>
              ),
            },
            {
              key: "/blog",
              label: (
                <Link className="text-16-regular!" to={"/blog"}>
                  مقالات
                </Link>
              ),
            },
          ],
        },
        {
          key: "courses",
          label: <span className="text-16-regular!">دوره ها</span>,
          icon: (
            <Icon
              className="mr-1.5!"
              icon={"solar:square-academic-cap-2-bold-duotone"}
            />
          ),
          children: [
            {
              key: "/department-category",
              label: (
                <Link className="text-16-regular!" to={"/department-category"}>
                  مدیریت دپارتمان و دسته بندی
                </Link>
              ),
            },
            {
              key: "/manage-course-features",
              label: (
                <Link
                  className="text-16-regular!"
                  to={"/manage-course-features"}
                >
                  مدیریت ویژگی های دوره
                </Link>
              ),
            },
            {
              key: "/courses",
              label: (
                <Link className="text-16-regular!" to={"/courses"}>
                  مدیریت دوره ها
                </Link>
              ),
            },
          ],
        },
        {
          key: "content-management",
          label: <span className="text-16-regular!">مدیریت محتوا صفحات</span>,
          icon: (
            <Icon
              className="mr-1.5!"
              icon={"solar:card-transfer-bold-duotone"}
            />
          ),
          children: [
            {
              key: "/institution",
              label: (
                <Link className="text-16-regular!" to={"/institution"}>
                  مدیریت نهاد ها
                </Link>
              ),
            },
            {
              key: "/slider-page",
              label: (
                <Link className="text-16-regular!" to={"/slider-page"}>
                  مدیریت اسلایدر
                </Link>
              ),
            },
            {
              key: "/testimonial",
              label: (
                <Link className="text-16-regular!" to={"/testimonial"}>
                  نظرات کاربران ویژه
                </Link>
              ),
            },
            {
              key: "/customer-list",
              label: (
                <Link className="text-16-regular!" to={"/customer-list"}>
                  مشتریان
                </Link>
              ),
            },
            {
              key: "/certificate-list",
              label: (
                <Link className="text-16-regular!" to={"/certificate-list"}>
                  گواهینامه ها
                </Link>
              ),
            },
            {
              key: "/permission-list",
              label: (
                <Link className="text-16-regular!" to={"/permission-list"}>
                  مجوز ها
                </Link>
              ),
            },
          ],
        },
      ],
    },
    {
      key: "products-and-sales",
      label: <span className="text-16-regular">محصولات و فروش</span>,
      type: "group",
      children: [
        {
          key: "product-management",
          label: <span className="text-16-regular!">مدیریت محصولات</span>,
          icon: (
            <Icon
              className="mr-1.5!"
              icon={"solar:checklist-minimalistic-bold-duotone"}
            />
          ),
          children: [
            {
              key: "/category",
              label: (
                <Link className="text-16-regular!" to={"/category"}>
                  دسته بندی محصولات
                </Link>
              ),
            },
            {
              key: "/product-list",
              label: (
                <Link className="text-16-regular!" to={"/product-list"}>
                  لیست محصولات
                </Link>
              ),
            },
          ],
        },
        {
          key: "invoices",
          label: <span className="text-16-regular!">مدیریت فروش</span>,
          icon: (
            <Icon
              className="mr-1.5!"
              icon={"solar:clipboard-list-bold-duotone"}
            />
          ),
          children: [
            {
              key: "/invoices-list",
              label: (
                <Link className="text-16-regular!" to={"/invoices-list"}>
                  لیست فاکتور ها
                </Link>
              ),
            },
            {
              key: "/management-discount-code",
              label: (
                <Link
                  className="text-16-regular!"
                  to={"/management-discount-code"}
                >
                  مدیریت کد های تخفیف
                </Link>
              ),
            },
            {
              key: "/print-management",
              label: (
                <Link className="text-16-regular!" to={"/print-management"}>
                  مدیریت چاپ
                </Link>
              ),
            },
            {
              key: "/shipping-method",
              label: (
                <Link className="text-16-regular!" to={"/shipping-method"}>
                  روش های ارسال
                </Link>
              ),
            },
          ],
        },
      ],
    },
    {
      key: "setting",
      label: <span className="text-16-regular">تنظیمات سامانه</span>,
      type: "group",
      children: [
        {
          key: "information-management",
          label: <span className="text-16-regular!">مدیریت اطلاعات</span>,
          icon: (
            <Icon className="mr-1.5!" icon={"solar:monitor-bold-duotone"} />
          ),
          children: [
            {
              key: "/setting",
              label: (
                <Link className="text-16-regular!" to={"/setting"}>
                  تنظیمات
                </Link>
              ),
            },
            {
              key: "/social-network-setting",
              label: (
                <Link
                  className="text-16-regular!"
                  to={"/social-network-setting"}
                >
                  تنظیمات شبکه های اجتماعی
                </Link>
              ),
            },
            {
              key: "/contact-information",
              label: (
                <Link className="text-16-regular!" to={"/contact-information"}>
                  اطلاعات تماس
                </Link>
              ),
            },
            {
              key: "/management-page",
              label: (
                <Link className="text-16-regular!" to={"/management-page"}>
                  مدیریت صفحات
                </Link>
              ),
            },
            {
              key: "/branch-list",
              label: (
                <Link className="text-16-regular!" to={"/branch-list"}>
                  مدیریت شعب
                </Link>
              ),
            },
          ],
        },
        {
          key: "access-management",
          label: (
            <Link className="text-16-regular!" to={"/"}>
              مدیریت دسترسی
            </Link>
          ),
          icon: <Icon className="mr-1.5!" icon={"solar:key-bold-duotone"} />,
        },
      ],
    },
  ];

  // const items: MenuItem[] = [
  //   {
  //     key: "/",
  //     label: (
  //       <Link className="text-16-regular!" to={"/"}>
  //         داشبورد
  //       </Link>
  //     ),
  //     icon: <Icon className="mr-1.5!" icon={"solar:widget-bold-duotone"} />,
  //   },
  //   {
  //     key: "analyze",
  //     label: (
  //       <Link className="text-16-regular!" to={"/"}>
  //         آنالیز
  //       </Link>
  //     ),
  //     icon: <Icon className="mr-1.5!" icon={"solar:chart-bold-duotone"} />,
  //   },
  //   {
  //     key: "content-management",
  //     label: <span className="text-16-regular">مدیریت محتوا</span>,
  //     type: "group",
  //     children: [
  //       {
  //         key: "news",
  //         label: <span className="text-16-regular!">اخبار و مقالات</span>,
  //         icon: <Icon className="mr-1.5!" icon={"solar:notes-bold-duotone"} />,
  //         children: [
  //           {
  //             key: "/blog-category",
  //             label: (
  //               <Link className="text-16-regular!" to={"/blog-category"}>
  //                 دسته‌بندی مقالات
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/blog",
  //             label: (
  //               <Link className="text-16-regular!" to={"/blog"}>
  //                 بلاگ
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/management-page",
  //             label: (
  //               <Link className="text-16-regular!" to={"/management-page"}>
  //                 صفحات ثابت
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/slider-page",
  //             label: (
  //               <Link className="text-16-regular!" to={"/slider-page"}>
  //                 مدیریت اسلایدرها
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/testimonial",
  //             label: (
  //               <Link className="text-16-regular!" to={"/testimonial"}>
  //                 نظرات کاربران
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/institution",
  //             label: (
  //               <Link className="text-16-regular!" to={"/institution"}>
  //                 مدیریت نهادها و همکاران
  //               </Link>
  //             ),
  //           },
  //         ],
  //       },
  //       {
  //         key: "courses",
  //         label: <span className="text-16-regular!">تعامل و پشتیبانی</span>,
  //         icon: (
  //           <Icon
  //             className="mr-1.5!"
  //             icon={"solar:square-academic-cap-2-bold-duotone"}
  //           />
  //         ),
  //         children: [
  //           {
  //             key: "/ticket",
  //             label: (
  //               <Link className="text-16-regular!" to={"/ticket"}>
  //                 تیکت ها
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/ticket-category",
  //             label: (
  //               <Link className="text-16-regular!" to={"/ticket-category"}>
  //                 دسته‌بندی تیکت‌ها
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/faq-category",
  //             label: (
  //               <Link className="text-16-regular!" to={"/faq-category"}>
  //                 دسته‌بندی سوالات
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/faq",
  //             label: (
  //               <Link className="text-16-regular!" to={"/faq"}>
  //                 مدیریت سوالات
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/management-information-contact-us",
  //             label: (
  //               <Link
  //                 className="text-16-regular!"
  //                 to={"/management-information-contact-us"}
  //               >
  //                 تماس با ما
  //               </Link>
  //             ),
  //           },
  //         ],
  //       },
  //       {
  //         key: "content-management",
  //         label: <span className="text-16-regular!">کاربران و دسترسی</span>,
  //         icon: (
  //           <Icon
  //             className="mr-1.5!"
  //             icon={"solar:card-transfer-bold-duotone"}
  //           />
  //         ),
  //         children: [
  //           {
  //             key: "/",
  //             label: (
  //               <Link className="text-16-regular!" to={"/"}>
  //                 لیست کاربران
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/",
  //             label: (
  //               <Link className="text-16-regular!" to={"/"}>
  //                 مدیریت مدرسین
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/",
  //             label: (
  //               <Link className="text-16-regular!" to={"/"}>
  //                 سطوح دسترسی
  //               </Link>
  //             ),
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     key: "products-and-sales",
  //     label: <span className="text-16-regular">محصولات و فروش</span>,
  //     type: "group",
  //     children: [
  //       {
  //         key: "support",
  //         label: <span className="text-16-regular!">فروشگاه</span>,
  //         icon: (
  //           <Icon
  //             className="mr-1.5!"
  //             icon={"solar:headphones-round-bold-duotone"}
  //           />
  //         ),
  //         children: [
  //           {
  //             key: "/product-list",
  //             label: (
  //               <Link className="text-16-regular!" to={"/product-list"}>
  //                 لیست محصولات
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/category",
  //             label: (
  //               <Link className="text-16-regular!" to={"/category"}>
  //                 دسته بندی محصولات
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/invoices-list",
  //             label: (
  //               <Link className="text-16-regular!" to={"/invoices-list"}>
  //                 فاکتورها و سفارشات
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/management-discount-code",
  //             label: (
  //               <Link
  //                 className="text-16-regular!"
  //                 to={"/management-discount-code"}
  //               >
  //                 کدهای تخفیف
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/shipping-method",
  //             label: (
  //               <Link className="text-16-regular!" to={"/shipping-method"}>
  //                 روش‌های ارسال
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/print-management",
  //             label: (
  //               <Link className="text-16-regular!" to={"/print-management"}>
  //                 مدیریت چاپ
  //               </Link>
  //             ),
  //           },
  //         ],
  //       },
  //       {
  //         key: "FAQ",
  //         label: <span className="text-16-regular!">آموزش</span>,
  //         icon: (
  //           <Icon
  //             className="mr-1.5!"
  //             icon={"solar:question-circle-bold-duotone"}
  //           />
  //         ),
  //         children: [
  //           {
  //             key: "/department-category",
  //             label: (
  //               <Link className="text-16-regular!" to={"/department-category"}>
  //                 دپارتمان‌ها و دسته‌بندی‌ها
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/courses",
  //             label: (
  //               <Link className="text-16-regular!" to={"/courses"}>
  //                 مدیریت دوره ها
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/manage-course-features",
  //             label: (
  //               <Link
  //                 className="text-16-regular!"
  //                 to={"/manage-course-features"}
  //               >
  //                 مدیریت ویژگی های دوره
  //               </Link>
  //             ),
  //           },
  //         ],
  //       },
  //       // {
  //       //   key: "product-management",
  //       //   label: <span className="text-16-regular!">مدیریت محصولات</span>,
  //       //   icon: (
  //       //     <Icon
  //       //       className="mr-1.5!"
  //       //       icon={"solar:checklist-minimalistic-bold-duotone"}
  //       //     />
  //       //   ),
  //       //   children: [],
  //       // },

  //       // {
  //       //   key: "invoices",
  //       //   label: <span className="text-16-regular!">مدیریت فروش</span>,
  //       //   icon: (
  //       //     <Icon
  //       //       className="mr-1.5!"
  //       //       icon={"solar:clipboard-list-bold-duotone"}
  //       //     />
  //       //   ),
  //       //   children: [],
  //       // },
  //     ],
  //   },
  //   {
  //     key: "setting",
  //     label: <span className="text-16-regular">تنظیمات سامانه</span>,
  //     type: "group",
  //     children: [
  //       {
  //         key: "product-management",
  //         label: <span className="text-16-regular!">تنظیمات سیستمی</span>,
  //         icon: (
  //           <Icon
  //             className="mr-1.5!"
  //             icon={"solar:checklist-minimalistic-bold-duotone"}
  //           />
  //         ),
  //         children: [
  //           {
  //             key: "/setting",
  //             label: (
  //               <Link className="text-16-regular!" to={"/setting"}>
  //                 تنظیمات عمومی
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/branch-list",
  //             label: (
  //               <Link className="text-16-regular!" to={"/branch-list"}>
  //                 مدیریت اطلاعات تماس و شعب
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/social-network-setting",
  //             label: (
  //               <Link
  //                 className="text-16-regular!"
  //                 to={"/social-network-setting"}
  //               >
  //                 شبکه‌های اجتماعی
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/",
  //             label: (
  //               <Link className="text-16-regular!" to={"/"}>
  //                 تنظیمات درگاه و پیامک
  //               </Link>
  //             ),
  //           },
  //           {
  //             key: "/contact-information",
  //             label: (
  //               <Link className="text-16-regular!" to={"/contact-information"}>
  //                 اطلاعات تماس
  //               </Link>
  //             ),
  //           },
  //         ],
  //       },
  //       // {
  //       //   key: "information-management",
  //       //   label: <span className="text-16-regular!">مدیریت اطلاعات</span>,
  //       //   icon: (
  //       //     <Icon className="mr-1.5!" icon={"solar:monitor-bold-duotone"} />
  //       //   ),
  //       //   children: [],
  //       // },
  //       {
  //         key: "access-management",
  //         label: (
  //           <Link className="text-16-regular!" to={"/"}>
  //             مدیریت دسترسی
  //           </Link>
  //         ),
  //         icon: <Icon className="mr-1.5!" icon={"solar:key-bold-duotone"} />,
  //       },
  //     ],
  //   },
  // ];
  return (
    <Sider
      collapsed={collapsed}
      width={"21rem"}
      className=" relative bg-transparent!"
    >
      <Button
        onClick={() => setCollapsed(!collapsed)}
        className="w-9! h-9! bg-white! rounded-xl! z-50! border-grayscale-200! absolute! p-0! top-8! -translate-x-1/2 left-0!"
      >
        {/* <Icon
          icon={"solar:alt-arrow-left-line-duotone"}
          className={`text-grayscale-950! duration-200 ${
            collapsed ? "" : "rotate-y-180"
          }`}
          width={20}
          height={20}
        /> */}
        <div
          className={`text-grayscale-950! w-5 h-5 duration-200 ${
            collapsed ? "" : "rotate-y-180"
          }`}
        >
          <ArrowLeft />
        </div>
      </Button>
      <div className={`w-full pt-6 gap-9 h-full flex flex-col`}>
        {/* logo */}
        <Activity mode={collapsed ? "hidden" : "visible"}>
          <div className="w-[70%] px-6">
            <img className="w-full" src="/image/Logo(2).png" alt="" />
          </div>
        </Activity>
        <Activity mode={collapsed ? "visible" : "hidden"}>
          <div className="w-full px-6">
            <div className="w-10 h-10 overflow-hidden">
              <img
                className="w-full h-full object-contain"
                src="/image/Vector(1).png"
                alt=""
              />
            </div>
          </div>
        </Activity>
        {/* list menu */}
        <div className="flex flex-col flex-1">
          <Menu
            className={`border-none! overflow-y-auto! h-[calc(100svh-12.5svh)] ${
              collapsed ? "" : "px-6!"
            }`}
            mode="inline"
            inlineCollapsed={collapsed}
            items={items}
            selectedKeys={[location.pathname]}
          />
        </div>
      </div>
    </Sider>
  );
}
